import { Box, Typography } from "../legacy-ui/materialCompat";
import { CategoriesSlider } from "./contentList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useRef } from "react";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../utils/focusScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

const MoftabakhContent = ({ data }) => {
  const { ref, focusKey } = useFocusable();

  const innerRef = useRef(null);
  const { isMouseFocus } = useInputMode();

  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const targetScroll = getVerticalFocusScrollTarget(ref.current, props || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <div className="legacy-route-content">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-route-scroll" ref={ref}>
          <div>
            <div className="flex items-center mb-5">
              <BackBarButtonMini />
              <Typography
                variant="h4"
                fontWeight={700}
                mb={0}
                mr={3}
                color={"white"}
              >
                اکران آنلاین
              </Typography>
            </div>
            {data.length > 0 ? (
              <CategoriesSlider
                rowTitle={""}
                movies={data}
                onFocus={onRowFocus}
              />
            ) : (
              <div className="bg-[#212121] p-5 rounded-xl text-lg">
                <Typography color={"white"} fontFamily={"AnjomanMaxFN-Regular"}>
                  {" "}
                  محتوایی یافت نشد
                </Typography>
              </div>
            )}
          </div>
        </div>
      </FocusContext.Provider>
    </div>
  );
};

export default MoftabakhContent;
